module.exports = __webpack_public_path__ + "assets/img/no-notice.24ab20f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-notice.png
// module id = FC3P
// module chunks = 1